import { Container } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import { CompaniesCards } from '@/components/companies/CompaniesCards';
import { WelcomeHeader } from '@/components/companies/WelcomeHeader';
import { Toaster } from '@/components/ui/toaster.tsx';

export const Route = createFileRoute('/companies')({
  component: Companies,
});

function Companies() {
  return (
    <Container maxW="full" pb={16}>
      <WelcomeHeader />
      <CompaniesCards />
      <Toaster />
    </Container>
  );
}
